export default __webpack_public_path__ + "static/tasks-bc128a13ac52d5776eb5e5df6819e0c2.svg";